module.exports = __webpack_public_path__ + "static/media/Version.ce9a50ef.txt";


//////////////////
// WEBPACK FOOTER
// ./src/Version.txt
// module id = 127
// module chunks = 1